"use strict";
var Observable_1 = require('../../Observable');
var catch_1 = require('../../operator/catch');
Observable_1.Observable.prototype.catch = catch_1._catch;
Observable_1.Observable.prototype._catch = catch_1._catch;



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/catch.js
// module id = 55
// module chunks = 0 1